/** Ultra-wide layouts (4K / super-wide monitors). */
export const ULTRA_WIDE_MIN_PX = 2000;
export const ULTRA_WIDE_MEDIA = `(min-width: ${ULTRA_WIDE_MIN_PX}px)`;
